export const baseNftFields = `
  tokenId
  otherId
  metadataUrl
  currentAskPrice
  currentSeller
  latestTradedPriceInPLS
  tradeVolumePLS
  totalTrades
  isTradable
  updatedAt
  otherId
  collection {
    id
  }
`

export const baseTransactionFields = `
  id
  block
  timestamp
  askPrice
  netPrice
  withPLS
  buyer {
    id
  }
  seller {
    id
  }
`

export const collectionBaseFields = `
  id
  name
  symbol
  active
  totalTrades
  totalVolumePLS
  numberTokensListed
  creatorAddress
  tradingFee
  creatorFee
  whitelistChecker
`
